<template>
  <div :style="`padding-left: ${margin_left_right}px; padding-right: ${margin_left_right}px;`">
    <table role="presentation" border="0" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td aria-hidden="true" :height="margin_top" :style="`font-size: 0px; line-height: 0px; ${borderStyle}`">
          &nbsp;
        </td>
      </tr>
      <tr>
        <td aria-hidden="true" :height="margin_bottom" style="font-size: 0px; line-height: 0px;">
          &nbsp;
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
  export default {
    props: {
      block: Object,
    },
    computed: {
      borderStyle() {
        return this.block.meta &&
          this.block.meta.line_width &&
          this.block.meta.line_color ?
            `border-bottom: ${this.block.meta.line_width}px solid ${this.block.meta.line_color};` :
            ''
      },
      margin_top() {
        if (!this.block.meta) return 20
        if (this.block.meta.margin_top || this.block.meta.margin_top === 0)
          return this.block.meta.margin_top
        if (this.block.meta.height || this.block.meta.height === 0)
          return Math.floor(this.block.meta.height/2)
        return 20
      },
      margin_bottom() {
        if (!this.block.meta) return 20
        if (this.block.meta.margin_bottom || this.block.meta.margin_bottom === 0)
          return this.block.meta.margin_bottom
        if (this.block.meta.margin_top || this.block.meta.margin_top === 0)
          return this.block.meta.margin_top
        if (this.block.meta.height || this.block.meta.height === 0)
          return Math.floor(this.block.meta.height/2)
        return 20
      },
      margin_left_right() {
        if (!this.block.meta) return 0
        return this.block.meta.margin_left_right || 0
      },
    },
    mounted() {
      window['spacer'+this.block.id] = this
    },
  }
</script>